// Fields not ready by API -- putting them aside for now
// const notready = [
//   {
//     name: 'emailAddressPartial',
//     label: 'Partial Email Address',
//     col: 6,
//   },
//   {
//     name: 'preferredCustomer',
//     label: 'Preferred Customer',
//     type: 'boolean',
//     control: 'checkbox',
//     options: [true, false],
//     col: 4,
//   },
//   {
//     name: 'includeOtherCountries',
//     label: 'Include Other Countries',
//     type: 'boolean',
//     control: 'checkbox',
//     options: [true, false],
//     col: 8,
//   },
// ];

const address = [
  {
    name: 'address1',
    label: 'Address Line 1',
    required: true,
  },
  {
    name: 'address2',
    label: 'Address Line 2',
  },
  {
    name: 'city',
    label: 'City',
    col: 6,
    required: true,
  },
  {
    name: 'state',
    label: 'State',
    col: 3,
    required: true,
  },
  {
    name: 'zipCode',
    label: 'Zip Code',
    col: 3,
    required: true,
  },
  {
    name: 'country',
    label: 'Country',
    col: 4,
    noEmptyOption: true,
    options: [
      { label: 'United States', value: 'US' },
      { label: 'Canada', value: 'CA' },
    ],
    required: true,
  },
];

const searchCustomer = [
  {
    name: 'externalCustomerId',
    label: 'External Customer ID',
    col: {
      sm: 4,
      md: 4,
      lg: 3,
    },
  },
  {
    name: 'firstName',
    label: 'First Name',
    col: {
      sm: 4,
      md: 4,
      lg: 3,
    },
  },
  {
    name: 'lastName',
    label: 'Last Name',
    col: {
      sm: 4,
      md: 4,
      lg: 3,
    },
  },
  {
    name: 'companyName',
    label: 'Company',
    col: {
      sm: 6,
      md: 6,
      lg: 3,
    },
  },
  {
    name: 'emailAddress',
    label: 'Email Address',
    type: 'email',
    col: {
      sm: 6,
      md: 6,
      lg: 3,
    },
  },
  {
    name: 'phoneNumber',
    label: 'Phone Number',
    col: {
      sm: 6,
      md: 6,
      lg: 3,
    },
  },
  {
    name: 'zipCode',
    label: 'Zip Code',
    col: {
      sm: 6,
      md: 6,
      lg: 3,
    },
  },
];

const updateCustomerLayout = [
  {
    type: 'tab',
    label: 'Personal',
    fields: [
      {
        name: 'firstName',
        label: 'First Name',
        col: 6,
        required: true,
      },
      {
        name: 'lastName',
        label: 'Last Name',
        col: 6,
        required: true,
      },
      {
        name: 'company',
        label: 'Company Name',
        col: 6,
      },
      {
        name: 'customerNum',
        label: 'Customer',
        col: 6,
        validation: { page: 'PCU2', type: 'customer' },
      },
      {
        name: 'emailAddress',
        label: 'Email Address',
        type: 'email',
        col: 6,
        required: true,
      },
      {
        name: 'phoneNumber',
        label: 'Phone Number',
        type: 'phone',
        col: 4,
        required: true,
      },
      {
        name: 'isMobile',
        label: 'Mobile',
        options: [true, false],
        type: 'boolean',
        control: 'checkbox',
        col: 2,
      },
      { type: 'section', label: 'Address', fields: [...address] },
      {
        name: 'preferredDealer',
        label: 'Preferred Dealer',
        col: 4,
        required: true,
      },
      {
        name: 'businessRole',
        label: 'Business Role',
        options: [
          {
            label: 'Driver/Owner/Operator',
            value: 'DRIVEROWNEROPERATOR',
          },
          {
            label: 'Fleet Manager',
            value: 'FLEETMANAGER',
          },
          {
            label: 'Purchasing Manager',
            value: 'PURCHASINGMANAGER',
          },
          {
            label: 'Service Manager',
            value: 'SERVICEMANAGER',
          },
          {
            label: 'Other',
            value: 'OTHER',
          },
        ],
        col: 4,
        required: true,
        events: {
          blur: {
            update: [
              {
                field: 'driverType',
                value: '',
              },
              {
                field: 'fleetSize',
                value: '',
              },
              {
                field: 'otherBusinessRole',
                value: '',
              },
            ],
          },
        },
      },
      {
        name: 'driverType',
        label: 'Driver Type',
        col: 4,
        dependencies: {
          and: [{ '==': ['businessRole', 'DRIVEROWNEROPERATOR'] }],
          action: 'show',
        },
        options: ['DRIVEROWNER', 'DRIVEROPERATOR'],
        required: true,
      },
      {
        name: 'otherBusinessRole',
        label: 'Other Business Role',
        col: 4,
        dependencies: {
          and: [{ '==': ['businessRole', 'OTHER'] }],
          action: 'show',
        },
        required: true,
      },
      {
        name: 'fleetSize',
        label: 'Fleet Size',
        col: 4,
        dependencies: {
          and: [{ '==': ['driverType', 'DRIVEROPERATOR'] }],
          action: 'hide',
        },
        required: true,
        options: [
          { label: '1 to 3', value: '1TO3' },
          { label: '4 to 6', value: '4TO6' },
          { label: '7 to 10', value: '7TO10' },
          { label: '11 to 20', value: '11TO20' },
          { label: '21 to 50', value: '21TO50' },
          { label: '51 to 75', value: '51TO75' },
          { label: '76 to 100', value: '76TO100' },
          { label: 'More than 100', value: '101PLUS' },
        ],
      },
    ],
  },
  {
    type: 'tab',
    label: 'Settings',
    fields: [
      {
        name: 'receiveMail',
        label: 'Would You Like to Receive Mail?',
        control: 'checkbox',
        type: 'boolean',
        options: [true, false],
      },
      {
        name: 'receiveEmail',
        label: 'Would You Like to Receive Email?',
        control: 'checkbox',
        type: 'boolean',
        options: [true, false],
      },
      {
        name: 'hasAcceptedEmailTerms',
        label: 'Accepted Email Terms',
        control: 'checkbox',
        type: 'boolean',
        options: [true, false],
      },
      {
        name: 'hasAcceptedLoyaltyTerms',
        label: 'Accepted Loyalty Terms',
        control: 'checkbox',
        type: 'boolean',
        options: [true, false],
      },
    ],
  },
];

const searchOffer = [
  {
    label: 'External Customer ID',
    name: 'externalCustomerId',
  },
  {
    type: 'section',
    label: 'Optional parameters',
    fields: [
      {
        name: 'couponCode',
        label: 'Coupon Code',
        col: 4,
      },
      {
        name: 'offerType',
        label: 'Offer Type',
        col: 4,
        options: [
          {
            label: 'Monthly - Parts',
            value: 'M',
          },
          {
            label: 'Monthly - Service',
            value: 'N',
          },
          {
            label: 'Yearly/Annual - Parts',
            value: 'Y',
          },
          {
            label: 'Yearly/Annual - Service',
            value: 'Z',
          },
          {
            label: 'OPC',
            value: 'O',
          },
          {
            label: 'Reward',
            value: 'R',
          },
          {
            label: 'Trigger',
            value: 'T',
          },
        ],
      },
      {
        name: 'printCode',
        label: 'Print Code',
        col: 4,
      },
      {
        name: 'offerCategory',
        label: 'Offer Category',
        col: 4,
      },
      {
        name: 'startDate',
        label: 'Start Date',
        col: 4,
        type: 'date',
      },
      {
        name: 'endDate',
        label: 'End Date',
        col: 4,
        type: 'date',
      },
      {
        name: 'partNumbers',
        label: 'Parts (Comma Separated)',
        col: {
          lg: 6,
          md: 12,
        },
      },
    ],
  },
];

export { updateCustomerLayout, searchCustomer, searchOffer };
